import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=6530f38a"
import script from "./Founder.vue?vue&type=script&lang=js"
export * from "./Founder.vue?vue&type=script&lang=js"
import style0 from "./Founder.vue?vue&type=style&index=0&id=6530f38a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports